function initCookies() {
    silktideCookieBannerManager.updateCookieBannerConfig({
        background: {
            showBackground: true
        },
        cookieIcon: {
            position: "bottomLeft"
        },
        cookieTypes: [
            {
                id: "necessary",
                name: "Necessary",
                description: "<p>Te pliki cookie s\u0105 niezb\u0119dne do prawid\u0142owego funkcjonowania witryny i nie mo\u017Cna ich wy\u0142\u0105czy\u0107. Pomagaj\u0105 one mi\u0119dzy innymi w logowaniu i ustawianiu preferencji prywatno\u015Bci.</p>",
                required: true,
                onAccept: function() {
                // console.log('Add logic for the required Necessary here');
                }
            },
            {
                id: "analytics",
                name: "Analytics",
                description: "<p>Te pliki cookie pomagaj\u0105 nam ulepsza\u0107 witryn\u0119, \u015Bledz\u0105c, kt\xf3re strony s\u0105 najpopularniejsze i w jaki spos\xf3b odwiedzaj\u0105cy poruszaj\u0105 si\u0119 po witrynie.</p>",
                required: false,
                onAccept: function() {
                    gtag('consent', 'update', {
                        analytics_storage: 'granted'
                    });
                    dataLayer.push({
                        'event': 'consent_accepted_analytics'
                    });
                },
                onReject: function() {
                    gtag('consent', 'update', {
                        analytics_storage: 'denied'
                    });
                }
            }
        ],
        text: {
            banner: {
                description: '<p>Na naszej stronie internetowej u\u017Cywamy plik\xf3w cookie w celu zwi\u0119kszenia komfortu u\u017Cytkowania, dostarczania spersonalizowanych tre\u015Bci i analizowania ruchu w witrynie. <a href="./files./policy.pdf" target="_blank">Cookie Policy.</a></p>',
                acceptAllButtonText: "Zaakceptuj wszystkie",
                acceptAllButtonAccessibleLabel: "Zaakceptuj wszystkie cookies",
                rejectNonEssentialButtonText: "Odrzu\u0107 opcjonalne",
                rejectNonEssentialButtonAccessibleLabel: "Odrzu\u0107 opcjonalne",
                preferencesButtonText: "Preferencje",
                preferencesButtonAccessibleLabel: "Prze\u0142\u0105cz preferencje"
            },
            preferences: {
                title: "Dostosuj swoje preferencje dotycz\u0105ce plik\xf3w cookie",
                description: "<p>Szanujemy Twoje prawo do prywatno\u015Bci. Mo\u017Cesz nie zezwoli\u0107 na niekt\xf3re rodzaje plik\xf3w cookie. Twoje preferencje dotycz\u0105ce plik\xf3w cookie b\u0119d\u0105 mia\u0142y zastosowanie na ca\u0142ej naszej stronie internetowej.</p>",
                creditLinkText: "Pobierz ten baner za darmo",
                creditLinkAccessibleLabel: "Pobierz ten baner za darmo"
            }
        }
    });
}
if (typeof silktideCookieBannerManager !== 'undefined') initCookies();

//# sourceMappingURL=landing.b0219ec9.js.map
